import styled from 'styled-components';
import { theme } from 'styles/theme';
import { Flex } from 'UI';

export const antdTokenForm = {
  token: {
    colorPrimary: theme.color.brand_black,
  },
  components: {
    Radio: {
      colorPrimary: theme.color.brand_black,
    },
  },
};

export const antdTokenHeader = {
  token: {
    colorPrimary: theme.color.palette_green_7,
  },
};

export const GarageBar = styled(Flex)`
  min-height: 120px;
  background: #eef2f5b2;
  border-radius: 13px;

  .ant-form-item {
    margin-bottom: 0px !important;
  }
`;

export const SFlexWrapper = styled(Flex)`
  border: 1px solid ${theme.color.grey85};
  border-radius: 10px;
  padding: 15px;
`;

export const DetailsSection = styled(Flex)`
  padding-top: 15px;
  border-top: 1px solid ${theme.color.grey85};
`;

export const DelimSection = styled(Flex)<{ inline?: boolean }>`
  border-bottom: 1px solid ${theme.color.grey85};
  margin: 0px -15px;
  padding: 0px 15px ${({ inline }) => (inline ? '10px' : '0px')} 15px;
`;
